import { Link } from '@inertiajs/react';
import type { ComponentProps } from 'react';
import posthog from 'posthog-js';

type PublicDemoLinkProps = ComponentProps<typeof Link> & {
  location: string;
};

export const PUBLIC_DEMO_CTA_CLICKED = 'cta.demo_request.click';

export function PublicDemoLink({ location, onClick, href, ...props }: PublicDemoLinkProps) {
  const destination = href ?? '/richiedi-demo';

  const handleClick: NonNullable<ComponentProps<typeof Link>['onClick']> = (event) => {
    onClick?.(event);

    if (event.defaultPrevented) {
      return;
    }

    posthog.capture(PUBLIC_DEMO_CTA_CLICKED, {
      cta_location: location,
      destination_path: destination,
    });
  };

  return <Link {...props} href={destination} onClick={handleClick} />;
}
